import Extension from "../base/extension";

class Nav extends Extension {
  #section;
  navDesktopOverlay;
  navDesktopItems;

  constructor(name) {
    super(name);
  }

  init() {
  this.#section = document.querySelector('.section-header');
  this.navDesktopOverlay = document.querySelector('.nav-desktop-overlay');
  this.navDesktopItems = document.querySelectorAll('#navbar nav .navbar-nav .nav-item.menu.dropdown');

  this.setupScrollListener();
  document.addEventListener('interaction:down-scroll', this.onScrollDown.bind(this));
  document.addEventListener('interaction:up-scroll', this.onScrollUp.bind(this));

  this.navDesktopItems.forEach(e => {
      e.addEventListener('mouseenter', () => {
        this.navDesktopOverlay.classList.add('show');
      });
      e.addEventListener('mouseleave', () => {
        this.navDesktopOverlay.classList.remove('show');
      });
    });
  }

  onScrollDown(e) {
    if (e.detail.difference > 5) {
      this.#section.classList.remove('scrolled-up');
      this.#section.classList.add('scrolled-down');
    }
  }

  onScrollUp(e) {
    if (e.detail.difference > 5) {
      this.#section.classList.remove('scrolled-down');
      this.#section.classList.add('scrolled-up');
    }
  }

  setupScrollListener() {
    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    window.addEventListener("scroll", () => {
      let st = window.pageYOffset || document.documentElement.scrollTop;
      let difference = Math.abs(st - lastScrollTop);

      if (st > lastScrollTop) {
        document.dispatchEvent(new CustomEvent("interaction:down-scroll", { detail: { difference } }));
      } else {
        document.dispatchEvent(new CustomEvent("interaction:up-scroll", { detail: { difference } }));
      }

      lastScrollTop = st <= 0 ? 0 : st;
    }, false);
  }
}

export default Nav;
